<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'Rozet Düzenle' : 'Yeni Rozet' }}</h5>
  <button type="button" class="close" (click)="dismiss()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label>Ad <span class="text-danger">*</span></label>
    <input type="text" class="form-control" [(ngModel)]="badge.name" placeholder="Rozet adı">
  </div>

  <div class="form-group">
    <label>Açıklama</label>
    <textarea class="form-control" [(ngModel)]="badge.description" rows="3" placeholder="Rozet açıklaması"></textarea>
  </div>

  <div class="form-group">
    <label>Görsel URL</label>
    <input type="text" class="form-control" [(ngModel)]="badge.image" placeholder="https://...">
    <div *ngIf="badge.image" class="mt-2 text-center">
      <img [src]="badge.image" style="width: 80px; height: 80px; object-fit: contain;" alt="Önizleme">
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-6">
      <label>Sıra</label>
      <input type="number" class="form-control" [(ngModel)]="badge.order" min="0">
    </div>
    <div class="form-group col-6 d-flex align-items-end">
      <div class="custom-control custom-switch mb-2">
        <input type="checkbox" class="custom-control-input" id="activeSwitch" [(ngModel)]="badge.active">
        <label class="custom-control-label" for="activeSwitch">Aktif</label>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismiss()">İptal</button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
    <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
    {{ isEditMode ? 'Güncelle' : 'Kaydet' }}
  </button>
</div>
